import { useInternationalization } from './useInternationalization';

export const usePageTitle = (key: string, options?: object | undefined) => {
  const { t } = useInternationalization();
  const text = t(key, options);
  document.title = `${text ? text + ' | ' : ''}Timbernet`;
};
